// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import getSystemsPriceAndInventory from "@plumberssupply/App/Handlers/SystemBuilder/getSystemsPriceAndInventory";
import {
    buildMiniSplitSystem,
    BuildMiniSplitSystemsResult,
    buildUnitarySystem,
    BuildUnitarySystemsResult,
} from "@plumberssupply/App/Services/SystemBuilderService";

interface Props {
    apiParameter: any;
    apiResult: BuildUnitarySystemsResult;
}

type Parameter = {
    onSuccess?: (result: any) => void;
    onError?: (e: any) => void;
    parameter: {
        brand: string;
        tons: number;
        indoorType: string;
        furnaceBtus: number;
        heatingMethod: string;
        coilWidth: string;
        electricHeaterKilowattRating: string;
    };
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await buildUnitarySystem(props.apiParameter.parameter);
};

export const onSuccess: HandlerType = props => {
    if (props.apiResult && props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult);
        if (props.apiResult.systems?.length) {
            props.dispatch(getSystemsPriceAndInventory({ systems: props.apiResult.systems }));
        }
    }
};

export const OnError: HandlerType = props => {
    if (props.apiResult && !props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult);
    }
};

export const chain = [PopulateApiParameters, RequestDataFromApi, onSuccess, OnError];

const buildUnitarySystems = createHandlerChainRunner(chain, "BuildUnitarySystems");
export default buildUnitarySystems;
